import axiosInstance from "../axiosInstance"
import type {
  ActionPriceResponseDto,
  CreateActionPriceDto,
  UpdateActionPriceDto,
  ActionPriceListParams,
  ActionPriceListResponseDto,
  DeleteActionPriceResponseDto,
} from "../types/actionPrice.types"

/**
 * Action Price API Client
 * Direct API calls using axios instance
 */
export const actionPriceClient = {
  // Get action price by ID (active only)
  getActionPriceById: (id: string): Promise<ActionPriceResponseDto> => {
    return axiosInstance.get(`/action-prices/${id}`)
  },

  // List action prices (admin, optional isActive filter)
  getActionPricesAdmin: (params?: ActionPriceListParams): Promise<ActionPriceListResponseDto> => {
    // Map frontend params to API parameter names
    const apiParams = params
      ? {
          page_number: params.page,
          limit_number: params.limit,
          category: params.category,
          actionType: params.actionType,
          isActive: params.isActive,
        }
      : undefined
    return axiosInstance.get("/action-prices/admin", { params: apiParams })
  },

  // Create action price (Admin only)
  createActionPrice: (data: CreateActionPriceDto): Promise<ActionPriceResponseDto> => {
    return axiosInstance.post("/action-prices", data)
  },

  // Update action price (Admin only)
  updateActionPrice: (
    id: string,
    data: UpdateActionPriceDto
  ): Promise<ActionPriceResponseDto> => {
    return axiosInstance.put(`/action-prices/${id}`, data)
  },

  // Delete action price (Admin only)
  deleteActionPrice: (id: string): Promise<DeleteActionPriceResponseDto> => {
    return axiosInstance.delete(`/action-prices/${id}`)
  },
}

